export default {
  registerAgentAvatarConsumer(state, agentId) {
    if (state.consumers.agents[agentId] === undefined) {
      state.consumers.agents[agentId] = 1;
    } else {
      ++state.consumers.agents[agentId];
    }
  },

  unregisterAgentAvatarConsumer(state, agentId) {
    if (state.consumers.agents[agentId] === 1) {
      delete state.consumers.agents[agentId];
      delete state.avatars.agents[agentId];
    } else {
      --state.consumers.agents[agentId];
    }
  },

  setAgentAvatar(state, { agentId, avatar }) {
    state.avatars.agents = {
      ...state.avatars.agents,
      [agentId]: avatar || null
    };
  },

  registerContactAvatarConsumer(state, contactId) {
    if (state.consumers.contacts[contactId] === undefined) {
      state.consumers.contacts[contactId] = 1;
    } else {
      ++state.consumers.contacts[contactId];
    }
  },

  unregisterContactAvatarConsumer(state, contactId) {
    if (state.consumers.contacts[contactId] === 1) {
      delete state.consumers.contacts[contactId];
      delete state.avatars.contacts[contactId];
    } else {
      --state.consumers.contacts[contactId];
    }
  },

  setContactAvatar(state, { contactId, avatar }) {
    state.avatars.contacts = {
      ...state.avatars.contacts,
      [contactId]: avatar || null
    };
  }
};
